import axios from 'axios';
import envService from "@/services/env.service";

const BASE_URL = envService.getApiBaseUrl() + '/sms/send';

export function postSendSms(webid, phoneNumber, text, tags) {

    return axios.post(BASE_URL,
        {
            "phoneNumber": phoneNumber,
            "text": text,
            "tag": tags
        },
        {
            headers: {
                'webid': webid
            },
        });
}
